import { TextHome } from 'src/pages/Home/TemplateHome'

const Home = () => <TextHome
  title="Mysellsy Demo Shop"
  paragraphs={[
    "Willkommen im Demo-Shop von Mysellsy.",
    "Dieser Shop dient als technische Demo für shop.mysellsy.de und das zugehörige Backend unter backend.mysellsy.de.",
    "Produkte, Warenkorb und Checkout können hier durchgespielt werden, ohne dass eine echte Zahlungsabwicklung gestartet wird.",
    "Als Zahlungsvariante steht bewusst nur eine Demo-Zahlung zur Verfügung. Beim Abschluss wird ein Hinweis im Modal angezeigt und es wird keine reale Zahlungsschnittstelle angesprochen.",
    "Damit eignet sich der Shop ideal für Abnahmen, Präsentationen und technische Tests des kompletten Frontend-/Backend-Setups.",
    "Viel Erfolg beim Testen."
]}
/>

export default Home
